module.exports = require("html-webpack-injector");